var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 8L7 11L13 5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square"}));
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Check;

Check.default = Check;
